import { useMutation } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { BuildVatSettlementRequest } from '@/api/handlers/resources/vat/requests';
import type { PrepareVatSettlementResponse } from '@/api/handlers/resources/vat/responses';
import type { ApiResponse } from '@/api/handlers/responses';

/**
 * Build the settlement DRAFT for a period.
 *
 * A mutation by shape only — it writes nothing. The server composes a balanced
 * entry and returns it **unsaved**; the ledger does not move until the user
 * reviews the draft in the Journal Entry form and posts it there. That is why
 * nothing is invalidated here: there is no server state to have gone stale. The
 * report is refetched from the form's `onSaved`, once something has actually
 * posted.
 *
 * Never rejects — callers branch on `success`.
 */
export const usePrepareVatSettlementMutation = () => {
    const { apiClient } = useApi();

    return useMutation<
        ApiResponse<PrepareVatSettlementResponse>,
        Error,
        BuildVatSettlementRequest
    >({
        mutationFn: (body) => apiClient.vat.buildSettlement(body),
    });
};
